/* ==========================================================================
   Mobile Improvements JavaScript - Casa Krysthal
   Version: 104 - Debug Mode - 2024-01-27
   ========================================================================== */

console.log('[Krysthal Mobile] Script loading - v189');

// Create debug status element (commented out - uncomment to enable)
/*
window.debugStatus = document.createElement('div');
window.debugStatus.id = 'krysthal-debug';
window.debugStatus.style.cssText = 'position: fixed; bottom: 10px; left: 10px; background: #333; color: white; padding: 10px; border-radius: 5px; font-size: 12px; z-index: 9999; max-width: 200px; font-family: monospace;';
window.debugStatus.textContent = 'Krysthal v189';
document.body.appendChild(window.debugStatus);
*/

document.addEventListener('DOMContentLoaded', function() {
  console.log('[Krysthal Mobile] DOM loaded, window width:', window.innerWidth);
  // debugStatus.textContent = 'DOM carregado: ' + window.innerWidth + 'px';
  
  // Note: Cart drawer functionality is handled by cart-drawer.liquid
  // It automatically intercepts all links with href="/cart"
  
  // Only run on mobile
  if (window.innerWidth <= 768) {
    
    /* ==========================================================================
       Footer Accordion
       ========================================================================== */
    const footerTitles = document.querySelectorAll('.footer-column:not(.footer-about) .footer-title');
    
    footerTitles.forEach(title => {
      // Make titles clickable
      title.style.cursor = 'pointer';
      
      title.addEventListener('click', function(e) {
        e.preventDefault();
        const column = this.parentElement;
        column.classList.toggle('expanded');
        
        // Close other sections
        footerTitles.forEach(otherTitle => {
          if (otherTitle !== title) {
            otherTitle.parentElement.classList.remove('expanded');
          }
        });
      });
    });
    
    /* ==========================================================================
       Mobile Filter Drawer
       ========================================================================== */
    window.toggleFilterDrawer = function() {
      const drawer = document.querySelector('.filter-drawer');
      const overlay = document.querySelector('.filter-overlay');
      
      if (drawer) {
        drawer.classList.toggle('active');
      }
      
      if (overlay) {
        overlay.classList.toggle('active');
      } else {
        // Create overlay if it doesn't exist
        const newOverlay = document.createElement('div');
        newOverlay.className = 'filter-overlay';
        newOverlay.onclick = toggleFilterDrawer;
        document.body.appendChild(newOverlay);
        setTimeout(() => newOverlay.classList.add('active'), 10);
      }
      
      // Prevent body scroll when drawer is open
      document.body.classList.toggle('drawer-open');
    };
    
    /* ==========================================================================
       Touch-friendly Product Cards
       ========================================================================== */
    const productCards = document.querySelectorAll('.product-card');
    
    productCards.forEach(card => {
      // Find all links in the card
      const links = card.querySelectorAll('a, .product-link');
      
      links.forEach(link => {
        // Remove onclick and ensure href is set
        if (link.hasAttribute('onclick')) {
          const onclickValue = link.getAttribute('onclick');
          const urlMatch = onclickValue.match(/window\.location\.href\s*=\s*['"]([^'"]+)['"]/);
          if (urlMatch) {
            link.setAttribute('href', urlMatch[1]);
            link.removeAttribute('onclick');
          }
        }
        
        // Ensure link is clickable
        link.style.cursor = 'pointer';
        link.style.pointerEvents = 'auto';
        
        // Prevent any parent element from blocking the click
        link.addEventListener('click', function(e) {
          if (this.href) {
            e.stopPropagation();
          }
        });
      });
      
      // Make entire card clickable if it has a main link
      const mainLink = card.querySelector('.product-link, .product-card-link');
      if (mainLink && mainLink.href) {
        card.style.cursor = 'pointer';
        card.addEventListener('click', function(e) {
          if (e.target.tagName !== 'A' && e.target.tagName !== 'BUTTON') {
            window.location.href = mainLink.href;
          }
        });
      }
    });
    
    /* ==========================================================================
       Lazy Loading Images
       ========================================================================== */
    if ('loading' in HTMLImageElement.prototype) {
      const images = document.querySelectorAll('img[loading="lazy"]');
      images.forEach(img => {
        img.src = img.src;
      });
    } else {
      // Fallback for browsers that don't support lazy loading
      const script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.3.2/lazysizes.min.js';
      document.body.appendChild(script);
    }
    
    /* ==========================================================================
       Smooth Scroll for Anchors
       ========================================================================== */
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
    
    /* ==========================================================================
       Mobile Search Improvements
       ========================================================================== */
    const mobileSearchInputs = document.querySelectorAll('.mobile-search-bar input, .mobile-sticky-search input');
    
    mobileSearchInputs.forEach(input => {
      // Prevent zoom on focus
      input.addEventListener('focus', function() {
        this.setAttribute('autocomplete', 'off');
        this.setAttribute('autocorrect', 'off');
        this.setAttribute('autocapitalize', 'off');
      });
    });
    
    /* ==========================================================================
       Mobile Sticky Header - DISABLED (using mobile-sticky-search-fix.js)
       ========================================================================== */
    /*
    let lastScrollTop = 0;
    
    // Wait a bit for DOM to be ready
    setTimeout(function() {
      // Create sticky header structure
      const stickyHeader = document.createElement('div');
      stickyHeader.className = 'mobile-sticky-header';
      stickyHeader.innerHTML = `
        <div class="mobile-sticky-inner">
          <button class="mobile-sticky-menu" onclick="toggleMobileMenu()" aria-label="Menu">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="3" y1="12" x2="21" y2="12"></line>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
          </button>
          <form action="/search" method="get" role="search" class="mobile-sticky-search">
            <input type="search" 
                   name="q" 
                   placeholder="O que deseja procurar?" 
                   aria-label="Buscar produtos"
                   autocomplete="off">
            <button type="submit" aria-label="Buscar">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M19 19L13 13M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
          </form>
          <button class="mobile-sticky-cart" onclick="openCartDrawer()" aria-label="Carrinho">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 22C9.55228 22 10 21.5523 10 21C10 20.4477 9.55228 20 9 20C8.44772 20 8 20.4477 8 21C8 21.5523 8.44772 22 9 22Z"/>
              <path d="M20 22C20.5523 22 21 21.5523 21 21C21 20.4477 20.5523 20 20 20C19.4477 20 19 20.4477 19 21C19 21.5523 19.4477 22 20 22Z"/>
              <path d="M1 1H5L7.68 14.39C7.77144 14.8504 8.02191 15.264 8.38755 15.5583C8.75318 15.8526 9.2107 16.009 9.68 16H19.4C19.8693 16.009 20.3268 15.8526 20.6925 15.5583C21.0581 15.264 21.3086 14.8504 21.4 14.39L23 6H6"/>
            </svg>
            <span class="cart-count mobile-sticky-cart-count" style="display: none;">0</span>
          </button>
        </div>
      `;
      
      // Insert sticky header at body start
      document.body.insertBefore(stickyHeader, document.body.firstChild);
      
      // Update cart count
      if (window.updateGlobalCartCount) {
        window.updateGlobalCartCount();
      }
      
      // Handle scroll for sticky header
      window.addEventListener('scroll', function() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        // Show sticky header after scrolling past header
        if (scrollTop > 150) {
          stickyHeader.classList.add('active');
          document.body.classList.add('sticky-search-visible');
        } else {
          stickyHeader.classList.remove('active');
          document.body.classList.remove('sticky-search-visible');
        }
        
        lastScrollTop = scrollTop;
      });
      
      // Setup search autocomplete for sticky header with debug
      const stickySearchInput = stickyHeader.querySelector('.mobile-sticky-search input');
      console.log('[Krysthal Mobile] Sticky search input found:', !!stickySearchInput);
      // debugStatus.textContent = 'Sticky input: ' + (stickySearchInput ? 'OK' : 'ERRO');
      
      if (stickySearchInput) {
        // Visual indicator removed for production
        // stickySearchInput.style.border = '2px solid red';
        setupSearchAutocomplete(stickySearchInput);
        
        // Test if events work
        stickySearchInput.addEventListener('focus', function() {
          // debugStatus.textContent = 'Sticky search FOCADO';
          console.log('[DEBUG] Sticky search focused');
        });
        
        stickySearchInput.addEventListener('input', function(e) {
          // debugStatus.textContent = 'Digitando sticky: ' + e.target.value;
          console.log('[DEBUG] Sticky input:', e.target.value);
        });
      }
      
    }, 100);
    */
  }
});

/* ==========================================================================
   Global Mobile Functions
   ========================================================================== */

// Open cart drawer
window.openCartDrawer = function() {
  const cartDrawer = document.getElementById('cartDrawer');
  const cartDrawerOverlay = document.getElementById('cartDrawerOverlay');
  
  if (cartDrawer) {
    cartDrawer.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  if (cartDrawerOverlay) {
    cartDrawerOverlay.classList.add('active');
  }
};

// Toggle mobile menu
window.toggleMobileMenu = function() {
  const mobileMenu = document.querySelector('.mobile-menu-drawer');
  const menuOverlay = document.querySelector('.mobile-menu-overlay');
  
  if (!mobileMenu) {
    // Create mobile menu if it doesn't exist
    const menu = document.createElement('div');
    menu.className = 'mobile-menu-drawer';
    menu.innerHTML = `
      <div class="mobile-menu-header">
        <button class="mobile-menu-close" onclick="toggleMobileMenu()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
        <span class="mobile-menu-title">Menu</span>
      </div>
      <nav class="mobile-menu-nav">
        <a href="/">Início</a>
        <a href="/collections/all">Todos os Produtos</a>
        <a href="/collections/barbantes">Barbantes</a>
        <a href="/collections/linhas">Linhas</a>
        <a href="/collections/las">Lãs</a>
        <a href="/collections/agulhas">Agulhas</a>
        <a href="/pages/sobre-nos">Sobre Nós</a>
        <a href="/pages/fale-conosco">Fale Conosco</a>
        <a href="https://rastreio.frenet.com.br/" target="_blank">Rastrear Pedido</a>
      </nav>
    `;
    document.body.appendChild(menu);
    
    // Create overlay
    const overlay = document.createElement('div');
    overlay.className = 'mobile-menu-overlay';
    overlay.onclick = toggleMobileMenu;
    document.body.appendChild(overlay);
    
    // Small delay to trigger animation
    setTimeout(() => {
      menu.classList.add('active');
      overlay.classList.add('active');
    }, 10);
  } else {
    // Toggle existing menu
    mobileMenu.classList.toggle('active');
    
    if (!menuOverlay) {
      const overlay = document.createElement('div');
      overlay.className = 'mobile-menu-overlay';
      overlay.onclick = toggleMobileMenu;
      document.body.appendChild(overlay);
      setTimeout(() => overlay.classList.add('active'), 10);
    } else {
      menuOverlay.classList.toggle('active');
    }
  }
  
  // Prevent body scroll
  document.body.classList.toggle('menu-open');
};

// Update cart count for mobile
window.updateMobileCartCount = function(count) {
  const mobileCartCounts = document.querySelectorAll('.mobile-cart-count');
  mobileCartCounts.forEach(cartCount => {
    if (count > 0) {
      cartCount.textContent = count;
      cartCount.style.display = 'flex';
    } else {
      cartCount.style.display = 'none';
    }
  });
};

// Add to existing updateGlobalCartCount if it exists
if (window.updateGlobalCartCount) {
  const originalUpdate = window.updateGlobalCartCount;
  window.updateGlobalCartCount = function() {
    originalUpdate();
    fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        updateMobileCartCount(data.item_count);
      });
  };
}

/* ==========================================================================
   Search Autocomplete
   ========================================================================== */

function setupSearchAutocomplete(input) {
  console.log('[Krysthal Search] Setting up autocomplete for:', input);
  if (!input) {
    console.log('[Krysthal Search] No input found, exiting');
    // debugStatus.textContent = 'Setup: input NULL';
    return;
  }
  
  const isSticky = input.closest('.mobile-sticky-search') !== null;
  console.log('[Krysthal Search] Is sticky search:', isSticky);
  // debugStatus.textContent = 'Setup: ' + (isSticky ? 'STICKY' : 'NORMAL');
  
  // Check if already initialized
  if (input.hasAttribute('data-search-initialized')) {
    console.log('[Krysthal Search] Already initialized, skipping');
    return;
  }
  input.setAttribute('data-search-initialized', 'true');
  console.log('[Krysthal Search] Initialized for input:', input.id || 'no-id');
  
  // Generate unique ID for this search instance
  const searchInstanceId = 'search-' + Math.random().toString(36).substr(2, 9);
  
  let searchTimeout;
  let currentRequest;
  
  // Create autocomplete container
  const autocompleteContainer = document.createElement('div');
  autocompleteContainer.className = 'search-autocomplete';
  autocompleteContainer.setAttribute('data-search-instance', searchInstanceId);
  autocompleteContainer.style.cssText = `
    position: fixed !important;
    background: white !important;
    border: 1px solid #e0e0e0 !important;
    border-radius: 5px !important;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1) !important;
    height: auto !important;
    min-height: 50px !important;
    max-height: 70vh !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    z-index: 2147483647 !important;
    display: none;
  `;
  
  // Position container relative to input's form
  const form = input.closest('form');
  if (!form) {
    console.error('[Krysthal Search] No form found for input!');
    // debugStatus.textContent = 'ERRO: sem form';
    return;
  }
  
  console.log('[Krysthal Search] Form found, appending container to body instead');
  // Don't append to form, append to body for better z-index control
  document.body.appendChild(autocompleteContainer);
  
  // Debug: Check if container was added
  console.log('[Krysthal Search] Container parent:', autocompleteContainer.parentElement);
  console.log('[Krysthal Search] Container in DOM:', document.contains(autocompleteContainer));
  
  // No need to check parent elements since container is now on body
  
  // Handle input events - iOS compatibility
  const handleSearch = function(e) {
    const query = e.target.value.trim();
    console.log('[Krysthal Search] Input event, query:', query);
    console.log('[Krysthal Search] Container exists:', !!autocompleteContainer);
    
    // Update debug status
    if (window.debugStatus) {
      const isSticky = e.target.closest('.mobile-sticky-search') !== null;
      window.debugStatus.textContent = (isSticky ? 'STICKY' : 'Normal') + ': ' + query;
    }
    
    clearTimeout(searchTimeout);
    
    if (query.length < 2) {
      console.log('[Krysthal Search] Query too short, hiding results');
      autocompleteContainer.style.display = 'none';
      autocompleteContainer.innerHTML = '';
      return;
    }
    
    searchTimeout = setTimeout(() => {
      if (window.debugStatus) {
        const isSticky = input.closest('.mobile-sticky-search') !== null;
        window.debugStatus.textContent = (isSticky ? 'STICKY' : 'Normal') + ' Buscando: ' + query;
      }
      
      // IMPORTANTE: Esconder TODOS os outros containers de autocomplete
      document.querySelectorAll('.search-autocomplete').forEach(el => {
        if (el !== autocompleteContainer) {
          el.style.display = 'none';
        }
      });
      
      // Show loading state
      autocompleteContainer.innerHTML = '<div style="padding: 15px; text-align: center; color: #999;">Buscando...</div>';
      autocompleteContainer.style.display = 'block';
      autocompleteContainer.style.visibility = 'visible';
      autocompleteContainer.style.opacity = '1';
      
      // Debug visual
      console.log('[DEBUG] Container should be visible now');
      console.log('[DEBUG] Container display:', autocompleteContainer.style.display);
      console.log('[DEBUG] Container parent:', autocompleteContainer.parentElement);
      
      // Debug: Force white background
      autocompleteContainer.style.backgroundColor = 'white !important';
      
      // Position loading state below input with forced styles
      const inputRect = input.getBoundingClientRect();
      const gap = 5;
      const topPosition = inputRect.bottom + gap;
      
      // Force position fixed and high z-index
      autocompleteContainer.style.cssText = autocompleteContainer.style.cssText + `
        position: fixed !important;
        top: ${topPosition}px !important;
        left: ${inputRect.left}px !important;
        width: ${inputRect.width}px !important;
        z-index: 2147483647 !important;
        display: block !important;
        visibility: visible !important;
        opacity: 1 !important;
      `;
      
      console.log('[DEBUG] Autocomplete positioned at:', {
        top: topPosition,
        left: inputRect.left,
        zIndex: autocompleteContainer.style.zIndex
      });
      
      // Use XMLHttpRequest for better compatibility
      const searchUrl = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`;
      console.log('[Krysthal Search] Fetching:', searchUrl);
      
      const xhr = new XMLHttpRequest();
      xhr.open('GET', searchUrl);
      xhr.setRequestHeader('Accept', 'application/json');
      
      xhr.onload = function() {
        console.log('[Krysthal Search] Response status:', xhr.status);
        if (xhr.status === 200) {
          try {
            console.log('[Krysthal Search] Raw response:', xhr.responseText.substring(0, 200));
            const data = JSON.parse(xhr.responseText);
            const products = data.resources?.results?.products || [];
            
            if (window.debugStatus) {
              const isSticky = input.closest('.mobile-sticky-search') !== null;
              window.debugStatus.textContent = (isSticky ? 'STICKY' : 'Normal') + ' Produtos: ' + products.length;
            }
            
            if (products.length > 0) {
              autocompleteContainer.innerHTML = '';
              autocompleteContainer.style.display = 'block';
              
              // Position container below search input with forced positioning
              const inputRect = input.getBoundingClientRect();
              const gap = 5; // 5px gap between input and results
              const topPosition = inputRect.bottom + gap;
              
              // Force styles to ensure visibility
              autocompleteContainer.style.cssText = autocompleteContainer.style.cssText + `
                position: fixed !important;
                top: ${topPosition}px !important;
                left: ${inputRect.left}px !important;
                width: ${inputRect.width}px !important;
                z-index: 2147483647 !important;
                display: block !important;
                visibility: visible !important;
                opacity: 1 !important;
                background: white !important;
              `;
              
              console.log('[Position Debug]', {
                inputTop: inputRect.top,
                inputBottom: inputRect.bottom,
                containerTop: topPosition,
                scrollY: window.scrollY
              });
              
              // Debug container visibility
              const rect = autocompleteContainer.getBoundingClientRect();
              console.log('Container visible:', rect);
              
              /*if (window.debugStatus) {
                window.debugStatus.textContent = `Produtos: ${products.length} | Container: ${rect.width}x${rect.height}`;
              }*/
              
              // Debug: Check first product data
              console.log('First product:', products[0]);
              /*if (window.debugStatus && products[0]) {
                window.debugStatus.innerHTML = `Produtos: ${products.length}<br>Primeiro: ${products[0].title ? products[0].title.substring(0, 20) : 'sem título'}`;
              }*/
              
              // Limit to 5 products
              const limitedProducts = products.slice(0, 5);
              
              limitedProducts.forEach(product => {
                const item = document.createElement('a');
                item.href = product.url;
                item.className = 'search-autocomplete-item';
                item.style.cssText = `
                  display: flex !important;
                  align-items: center !important;
                  padding: 8px 12px !important;
                  text-decoration: none !important;
                  color: #333 !important;
                  border-bottom: 1px solid #f0f0f0 !important;
                  background: white !important;
                  min-height: 45px !important;
                  box-sizing: border-box !important;
                `;
                
                const imageHtml = product.image 
                  ? `<img src="${product.image}" alt="${product.title}" style="width: 40px; height: 40px; object-fit: cover; margin-right: 10px; border-radius: 5px;">` 
                  : '';
                
                item.innerHTML = `
                  ${imageHtml}
                  <div style="flex: 1;">
                    <div style="font-weight: 500; margin-bottom: 2px; color: #333; font-size: 14px; line-height: 1.2;">${product.title}</div>
                    <div style="color: #F15A29; font-weight: bold; font-size: 13px;">R$ ${product.price}</div>
                  </div>
                `;
                
                // Add hover effect
                item.onmouseover = function() { this.style.background = '#f5f5f5'; };
                item.onmouseout = function() { this.style.background = 'white'; };
                
                autocompleteContainer.appendChild(item);
              });
              
              // Add "ver todos" link
              const viewAll = document.createElement('a');
              viewAll.href = `/search?q=${encodeURIComponent(query)}`;
              viewAll.className = 'search-autocomplete-view-all';
              viewAll.style.cssText = `
                display: block !important;
                padding: 10px !important;
                text-align: center !important;
                color: #F15A29 !important;
                font-weight: 600 !important;
                text-decoration: none !important;
                background: #f9f9f9 !important;
                border-radius: 0 0 5px 5px !important;
                font-size: 14px !important;
              `;
              viewAll.textContent = `Ver todos os resultados para "${query}"`;
              
              autocompleteContainer.appendChild(viewAll);
              
              // Force container to be visible and have proper height
              autocompleteContainer.style.display = 'block !important';
              autocompleteContainer.style.visibility = 'visible !important';
              autocompleteContainer.style.opacity = '1 !important';
              autocompleteContainer.style.height = 'auto !important';
              autocompleteContainer.style.minHeight = (products.length * 70 + 60) + 'px !important';
              
              // Force reflow
              autocompleteContainer.offsetHeight;
              
              // Update debug with final size and content check
              setTimeout(() => {
                const finalRect = autocompleteContainer.getBoundingClientRect();
                const computed = window.getComputedStyle(autocompleteContainer);
                const childCount = autocompleteContainer.children.length;
                const firstChild = autocompleteContainer.firstElementChild;
                const containerTop = finalRect.top;
                const containerLeft = finalRect.left;
                
                /*if (window.debugStatus) {
                  window.debugStatus.innerHTML = `Produtos: ${products.length} | Final: ${finalRect.width}x${finalRect.height}<br>` +
                    `Display: ${computed.display} | Filhos: ${childCount}<br>` +
                    `Primeiro: ${firstChild ? firstChild.tagName : 'vazio'}<br>` +
                    `Posição: T:${containerTop.toFixed(0)} L:${containerLeft.toFixed(0)}`;
                }*/
                
                // Log container HTML for debug
                console.log('Container HTML:', autocompleteContainer.innerHTML.substring(0, 300));
              }, 100);
              
            } else {
              autocompleteContainer.innerHTML = '<div style="padding: 15px; text-align: center; color: #999;">Nenhum produto encontrado</div>';
            }
          } catch (error) {
            console.error('Search parse error:', error);
            /*if (window.debugStatus) {
              window.debugStatus.textContent = 'Erro: ' + error.message;
            }*/
            autocompleteContainer.innerHTML = '<div style="padding: 15px; text-align: center; color: #999;">Erro ao processar busca</div>';
          }
        } else {
          /*if (window.debugStatus) {
            window.debugStatus.textContent = 'Erro HTTP: ' + xhr.status;
          }*/
          autocompleteContainer.innerHTML = '<div style="padding: 15px; text-align: center; color: #999;">Erro ao buscar produtos</div>';
        }
      };
      
      xhr.onerror = function() {
        /*if (window.debugStatus) {
          window.debugStatus.textContent = 'Erro de conexão';
        }*/
        autocompleteContainer.innerHTML = '<div style="padding: 15px; text-align: center; color: #999;">Erro de conexão</div>';
      };
      
      xhr.send();
    }, 300);
  };
  
  // Add multiple event listeners for iOS compatibility
  input.addEventListener('input', handleSearch);
  input.addEventListener('keyup', handleSearch);
  input.addEventListener('paste', handleSearch);
  input.addEventListener('change', handleSearch);
  
  // Test if events are working
  input.addEventListener('focus', function() {
    if (window.debugStatus) {
      const isSticky = this.closest('.mobile-sticky-search') !== null;
      window.debugStatus.textContent = (isSticky ? 'STICKY' : 'Normal') + ' campo ativo';
    }
    console.log('[DEBUG] Search input focused, sticky:', this.closest('.mobile-sticky-search') !== null);
  });
  
  // Track if we're clicking inside the autocomplete
  let clickingAutocomplete = false;
  
  autocompleteContainer.addEventListener('mousedown', function() {
    clickingAutocomplete = true;
  });
  
  autocompleteContainer.addEventListener('mouseup', function() {
    clickingAutocomplete = false;
  });
  
  // Hide on blur - but not if clicking autocomplete
  input.addEventListener('blur', function() {
    setTimeout(() => {
      if (!clickingAutocomplete) {
        autocompleteContainer.style.display = 'none';
      }
    }, 200);
  });
  
  // Hide on scroll and reposition if needed
  let scrollTimeout;
  window.addEventListener('scroll', function() {
    // Hide immediately when scrolling
    autocompleteContainer.style.display = 'none';
    
    // Clear any existing timeout
    clearTimeout(scrollTimeout);
    
    // If input is focused and has value, reshow after scroll stops
    scrollTimeout = setTimeout(() => {
      if (document.activeElement === input && input.value.trim().length >= 2) {
        const event = new Event('input', { bubbles: true });
        input.dispatchEvent(event);
      }
    }, 300);
  });
  
  // Hide on click outside
  document.addEventListener('click', function(e) {
    if (!input.contains(e.target) && !autocompleteContainer.contains(e.target)) {
      autocompleteContainer.style.display = 'none';
    }
  });
  
  // Show on focus if has value or show suggestions
  input.addEventListener('focus', function() {
    const query = this.value.trim();
    const isSticky = this.closest('.mobile-sticky-search') !== null;
    console.log('[DEBUG] Focus event - sticky:', isSticky, 'query:', query);
    
    // Small delay to avoid blur conflict
    setTimeout(() => {
      if (query.length >= 2) {
        const event = new Event('input', { bubbles: true });
        this.dispatchEvent(event);
      } else {
        // Show suggestions when field is empty
        console.log('[DEBUG] Trying to show suggestions, function exists:', typeof window.showSearchSuggestions === 'function');
        if (typeof window.showSearchSuggestions === 'function') {
          window.showSearchSuggestions(input, autocompleteContainer);
        } else {
          console.log('[Krysthal Search] showSearchSuggestions not found');
        }
      }
    }, 50); // Small delay to let focus settle
  });
}

// Show search suggestions
window.showSearchSuggestions = function(input, container) {
  console.log('[Krysthal Search] Showing suggestions for input:', input, 'container:', container);
  
  if (!container) {
    console.error('[Krysthal Search] No container provided for suggestions');
    return;
  }
  
  // IMPORTANTE: Esconder TODOS os outros containers de autocomplete
  document.querySelectorAll('.search-autocomplete').forEach(el => {
    if (el !== container) {
      el.style.display = 'none';
    }
  });
  
  const isSticky = input.closest('.mobile-sticky-search') !== null;
  console.log('[Krysthal Search] Showing suggestions for sticky:', isSticky);
  
  // if (window.debugStatus) {
  //   window.debugStatus.textContent = (isSticky ? 'STICKY' : 'Normal') + ' Sugestões';
  // }
  
  const suggestions = [
    { text: 'Barbantes', icon: '🧵' },
    { text: 'Agulhas', icon: '📍' },
    { text: 'Fio de malha', icon: '🧶' },
    { text: 'Lã', icon: '🧶' }
  ];
  
  container.innerHTML = '<div style="padding: 8px 12px; color: #666; font-size: 13px; border-bottom: 1px solid #f0f0f0; font-weight: 600;">Sugestões de busca:</div>';
  container.style.display = 'block';
  
  // Position suggestions below input with forced positioning
  const inputRect = input.getBoundingClientRect();
  const gap = 5;
  const topPosition = inputRect.bottom + gap;
  
  // Force positioning - override ALL previous styles to ensure visibility
  container.style.cssText = `
    position: fixed !important;
    top: ${topPosition}px !important;
    left: ${inputRect.left}px !important;
    width: ${inputRect.width}px !important;
    z-index: 2147483647 !important;
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
    background: white !important;
    border: 1px solid #e0e0e0 !important;
    border-radius: 5px !important;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1) !important;
    max-height: 70vh !important;
    overflow-y: auto !important;
  `;
  
  console.log('[Suggestions Position]', {
    inputBottom: inputRect.bottom,
    containerTop: topPosition,
    containerDisplay: container.style.display,
    containerVisible: container.style.visibility
  });
  
  // Force show the container
  setTimeout(() => {
    console.log('[DEBUG] Container after positioning:', {
      display: container.style.display,
      visibility: container.style.visibility,
      rect: container.getBoundingClientRect()
    });
  }, 100);
  
  suggestions.forEach(suggestion => {
    const item = document.createElement('a');
    item.href = `/search?q=${encodeURIComponent(suggestion.text)}`;
    item.style.cssText = `
      display: flex !important;
      align-items: center !important;
      padding: 10px 12px !important;
      text-decoration: none !important;
      color: #333 !important;
      border-bottom: 1px solid #f0f0f0 !important;
      background: white !important;
      min-height: 44px !important;
    `;
    
    item.innerHTML = `
      <span style="font-size: 18px; margin-right: 8px;">${suggestion.icon}</span>
      <span style="font-size: 14px;">${suggestion.text}</span>
    `;
    
    item.onmouseover = function() { this.style.background = '#f5f5f5'; };
    item.onmouseout = function() { this.style.background = 'white'; };
    
    item.onclick = function(e) {
      e.preventDefault();
      e.stopPropagation();
      input.value = suggestion.text;
      input.focus(); // Keep focus on input
      const event = new Event('input', { bubbles: true });
      input.dispatchEvent(event);
    };
    
    container.appendChild(item);
  });
};

// Alternative simple search for mobile
function setupSimpleSearch(input) {
  if (!input) return;
  
  let searchTimer;
  
  const performSearch = function() {
    const query = input.value.trim();
    if (query.length < 2) return;
    
    // Create a form dynamically and submit for search
    const searchForm = input.closest('form');
    if (searchForm && query.length >= 3) {
      // For now, just update the action to include the query
      searchForm.action = `/search?q=${encodeURIComponent(query)}`;
    }
  };
  
  input.addEventListener('input', function() {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(performSearch, 500);
  });
}

// Setup autocomplete for all search inputs
document.addEventListener('DOMContentLoaded', function() {
  console.log('[Krysthal Search] Checking for search inputs...');
  
  // Only run on mobile
  if (window.innerWidth <= 768) {
    // Wait a bit for DOM to be fully ready
    setTimeout(() => {
      console.log('[Krysthal Search] Looking for search inputs after delay...');
      
      // Try autocomplete first, fallback to simple search
      const searchInputs = document.querySelectorAll('#mobileSearchInput, .mobile-search-bar input[type="search"], .mobile-sticky-search input[type="search"]');
      console.log('[Krysthal Search] Found inputs:', searchInputs.length);
      if (window.debugStatus) { window.debugStatus.textContent = 'Inputs encontrados: ' + searchInputs.length; }
      
      searchInputs.forEach((input, index) => {
        console.log(`[Krysthal Search] Processing input ${index}:`, input.id, input.className);
        if (!input.hasAttribute('data-search-initialized')) {
          // Try full autocomplete
          try {
            setupSearchAutocomplete(input);
          } catch (e) {
            console.error('[Krysthal Search] Autocomplete error:', e);
            setupSimpleSearch(input);
          }
        }
      });
    }, 1000);
  } else {
    console.log('[Krysthal Search] Not mobile, skipping search setup');
  }
});

